<template>
	<div class="access-denied">
		<img
			class="access-denied__img"
			src="~@/assets/403.png"
			alt="No Entry graphic for access denied"
		/>
		<h2 class="access-denied__title">
			403 Restricted Area <br />Sorry, your access has been denied.
		</h2>
		<p class="access-denied__message">
			You do not currently have permission to view this page. <br />Please contact your manager.
		</p>
		<div class="access-denied__actions">
			<router-link to="/" class="btn btn--primary"
				>Go to Clients</router-link
			>
		</div>
	</div>
</template>

<script>
export default {
	name: 'AccessDenied'
};
</script>

<style lang="scss" scoped>
/**
    * Access denied
    * Can use SCSS variables = TRUE
*/

.access-denied {
	padding: $padding-sm * 9 0;
	margin: 0 auto;
	max-width: 420px;
	text-align: center;

	&__img {
		height: auto;
	}

	&__title {
		font-size: $default-font-size + 4;
		margin-bottom: $gutter-md;
		font-weight: $medium-font-weight;
		line-height: normal;
		@include text-contrast($page-body-bkgd, $white, $black);
	}

	&__message {
		font-size: $default-font-size - 2;
		@include text-contrast($page-body-bkgd, $white, $black);
	}

	&__actions {
		margin-top: $gutter-xl;
		.btn {
			display: inline-block;
		}
	}
}
</style>
